import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLoading } from "../../../context/LoadingContext";
import { Card, Container, Form, Button } from "react-bootstrap";
import InputSearch from "../../../components/InputSearhComponent";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import { getQueryString } from "../../../utils/Query";
import TableForm2s from "../../../components/TableFormScrb";
import { useNavigate } from "react-router-dom";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import ServiceRequestService from "../../../services/servicerequest.service";
import { useAlert } from "../../../context/AlertContext";
import { formatDate } from "../../../commons/FormatValue";
import TechItemReturnService from "../../../services/techitemreturn";
import JobTypeService from "../../../services/jobtype.service";
import { filteredNoneMultiItemInArray } from "../../../utils/ManageArray";

export default function ReturnEquipmentParts() {
  const navigate = useNavigate();
  const [JobType, setJobType] = useState([]);
  const [SeqNo, setSeqNo] = useState([]);
  const [loading, setLoading] = useState([]);
  const [data, setData] = useState([]);
  const { showAlert } = useAlert();
  const [currentPage, setCurrentPage] = useState()
  const [rowsPerPage, setRowsPerPage] = useState(15)
  const [allCountData, setAllCountData] = useState()
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getJobTypesForTechPlan(),
      callback: (res) => setJobType(filteredNoneMultiItemInArray(res, "Id"))
    });
  }, [])

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData?.team,
      disabled: true,
      size: 3
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData?.tech_name,
      disabled: true,
      size: 3
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 3,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: SeqNo
      }),
      required: true,
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechItemReturnService.getSeqNoTechItemReturn(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seq_no
            }))
            setSeqNo(newArray)
          }
        });
      }
    },
  ];

  const columns = [
    {
      name: "Rep_Date",
      label: "วันที่ตรวจรับ",
      readOnly: true
    },
    {
      name: "Rep_No",
      label: "เลขที่ตรวจรับ",
      readOnly: true
    },
    {
      name: "EquipmentCode",
      label: "รหัสอุปกรณ์/อะไหล่",
      width: "200px",
      readOnly: true
    },
    {
      name: "EquipmentName",
      label: "ชื่ออุปกรณ์/อะไหล่",
      showTooltip: true,
      width: "200px",
      readOnly: true
    },
    {
      name: "ModelNumber",
      label: "Model Number",
      width: "180px",
      readOnly: true
    },
    {
      name: "RequireQuantity",
      label: "เบิก",
      width: "80px",
      readOnly: true
    },
    {
      name: "ReceivedQuantity",
      label: "รับ",
      width: "80px",
      readOnly: true
    },
    {
      name: "ReturnQuantity",
      label: "คืน",
      width: "80px",
      readOnly: true
    },
    {
      name: "Unit",
      label: "หน่วย",
      readOnly: true
    },
  ];

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({ page: page, limit: limit, ...search })
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechItemReturnService.getTechItemReturnBySeq(q),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }
  function initData(data) {
    const newArray = data[0]?.BillOfReqHd.BillOfReqDt?.map((items) => ({
      ...items,
      // Rep_Date: formatDate(items.TechnicianPlan?.TechWorkClosed?.tech_work_close_date),
      // Rep_No: items.TechnicianPlan?.TechWorkClosed.service_rep_no,
      Rep_Date: formatDate(data[0].TechInspRevItem?.tech_insp_rev_date),
      Rep_No: data[0].TechInspRevItem?.tech_insp_rev_no,
      EquipmentCode: items.Item.Item_Code,
      EquipmentName: items.Item.Item_Name_EN || items.Item.Item_Name_TH,
      ModelNumber: items.Item.Item_Model,
      RequireQuantity: items.Req_Qty,
      ReceivedQuantity: items.Iss_Qty,
      ReturnQuantity: items.TechItemReturn?.item_return_qty,
      Unit: items.Item.Unit,
    }));
    setData({

      Seq_No: data[0].seq_no,
      // bill_of_req_hd.ref_do_no

      Cus_Code: data[0].SeqInstalljob.InformInstallJobs.Customer.Cus_Code,
      Cus_Name: data[0].SeqInstalljob.InformInstallJobs.Customer.Cus_Name,
      Cus_NumBranch: data[0].SeqInstalljob.InformInstallJobs.Customer.Cus_NumBranch,
      // Branch_Name: data[0].SeqInstalljob.InformInstallJobs.Customer.Cus_NumBranch,
      // : ,

      // : data[0].wh_code
      Remark: data[0]?.BillOfReqHd.Remark,
      table: newArray || []
    })
  }

  const handleValidated = (search, type) => {
    if (type == "submit") {
      if (search?.seq_no) {
        setValidated(false)
        getDataTable(search)
      } else {
        setValidated(true)
      }
    } else if (search?.seq_no) {
      setValidated(false)
    } else {
      setData({ ...data, table: [] })
      setValidated(false)

    }
  };

  return (
    <>
      <Helmet>
        <title>{"คืนอุปกรณ์/อะไหล่"}</title>
        <meta name="description" content="Return Equipment/Parts Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Title className="mb-4 mt-2 fs-2 text-center">
            ข้อมูลการคืนอุปกรณ์/อะไหล่
          </Card.Title>
          <Form noValidate validated={validated} >
            <InputSearch
              inputField={searchInput}
              field={searchInput}
              fieldClassName={{ inputRow: "justify-content-center", actionButton: "w-auto py-2" }}
              searchCallback={handleValidated}
            // searchByField={{ name: 'seq_no' }}
            />
          </Form>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดอุปกรณ์/อะไหล่
            </Card.Title>

            <Button
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("edit", { state: { JobType: JobType } })
              }
            >
              แก้ไขข้อมูลคืนอุปกรณ์/อะไหล่
            </Button>
          </Card.Header>

          <Form noValidate className="" >
            <TableForm2s
              data={data?.table || []}
              columns={columns}
              pending={loading}
              editForm={false}
              pagination={false}
            />
          </Form>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <div className="d-flex justify-content-center">
            <Button
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill"
              onClick={() => navigate("preview", {
                state: { data: data }
              })}
              disabled={!data.table?.length}
            >
              แสดงใบขอคืน
            </Button>
          </div>
        </Card>
      </Container>
    </>
  );
}
